import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import currencyFormatter from 'currency-formatter';
import { isAuthorized } from '@smarterservices/iam-react-client';

// Components
import PaymentSessions from './PaymentSessions';
import PaymentHistory from './PaymentHistory';
import PaymentCollect from './PaymentCollect';
import Drawer from '../Drawer/Drawer';

const Payments = observer(class Payments extends React.Component {
  constructor() {
    super();
    this.handleTabs = this.handleTabs.bind(this);
  }

  componentWillMount() {
    this.state = {
      activeTab: 1,
      collect: false,
      paymentType: null,
      drawerContent: null,
      drawerOpen: false
    }

    // Get locations to populate partial payment dropdown
    this.props.store.LocationStore.getLocations();
  }

  componentDidMount() {
    const { proctorAccountSid } = this.props.store.SessionStore.userData;
    const iam = sessionStorage.getItem('iam');

    if (!isAuthorized('sp:DescribeBalance', `ssrn:ss:sp::${proctorAccountSid}:balance`, iam)) {
      this.props.routing.history.push('/unauthorized');
    }
  }

  handleTabs(index) {
    this.setState({
      activeTab: index + 1,
    })
  }

  collectPayment(e, paymentType) {
    const { PaymentStore } = this.props.store;
    let typeDelay = null;

    // If we’re collecting the entire payment, make sure there are no dates or locations applied
    if(paymentType === 'full') {
      PaymentStore.balance = PaymentStore.totalBalance;
      PaymentStore.resetPaymentData();
    }

    // Open the slideout
    if(!this.state.collect || this.state.paymentType !== paymentType) {
      // Cancel any slide delay timeouts
      clearTimeout(typeDelay);

      // Remove the selected class from any previously-selected buttons
      const prevSelected = document.querySelector('.select-payment.selected');

      if(prevSelected) {
        prevSelected.className = prevSelected.className.replace('selected', '');
      }

      // Then add the selected class to this button and set state
      e.target.className += ' selected';

      this.setState({
        collect: true,
        paymentType
      });
    } else {
      e.target.className = e.target.className.replace('selected', '');

      this.setState({
        collect: false,
      });

      // Wait to change the payment type until the panel has finished sliding
      const _this = this;

      typeDelay = setTimeout(function(){
        _this.setState({
          paymentType: null
        });
      }, 250)
    }
  }

  renderResults() {
    const { translation } = this.props;
    const { PaymentStore, SessionStore } = this.props.store;
    const { totalBalance } = PaymentStore;
    const currency = SessionStore.defaultCurrency || 'USD';

    if(!SessionStore.loading || PaymentStore.totalBalance !== null) {
      // Don’t use the default tab styles
      Tabs.setUseDefaultStyles(false);

      return (
        <div>
          <div className="wrap wrap--medium">
            <article className="panel panel--medium">
              <span className="panel__subhdg">{translation.owe}</span>

              <span className="text-code">
                {currencyFormatter.format(totalBalance, {code: currency})}
              </span>

              {totalBalance !== 0 &&
                <p>{translation.payment_options}</p>
              }

              {totalBalance !== 0 &&
                <div className="button-group">
                  <button
                    className="btn btn--outline btn--inline select-payment"
                    onClick={(e) => this.collectPayment(e, 'partial')}
                  >
                    {translation.collect_part}
                  </button>

                  <button
                    className="btn btn--outline btn--inline select-payment"
                    onClick={(e) => this.collectPayment(e, 'full')}
                  >
                    {translation.collect_all}
                  </button>
                </div>
              }
            </article>

            <PaymentCollect
              paymentType={this.state.paymentType}
              open={this.state.collect}
              parent={this}
              {...this.props}
            />
          </div>

          <Tabs
            onSelect={this.handleTabs}
          >
            <TabList>
              <Tab>{translation.sessions}</Tab>
              <Tab>{translation.history}</Tab>
            </TabList>

            <TabPanel>
              <PaymentSessions currency={currency} {...this.props} />
            </TabPanel>

            <TabPanel>
              <PaymentHistory {...this.props} />
            </TabPanel>
          </Tabs>
        </div>
      )
    }

    return '';
  }

  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <div className="wrap">
          <header className="page__header">
            <h1 className="page__title">{translation.page_title}</h1>
          </header>

          {this.renderResults()}
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('Payments')(Payments);


// WEBPACK FOOTER //
// ./src/app/components/Payments/Payments.js